import "core-js/modules/es.function.name";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.replace";
import _objectSpread from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import setRules from '@/libs/rules';
import regAgreement from '../regAgreement/index.vue';
var rule = [{
  key: 'accountPhone',
  name: '手机号码',
  validator: 'validatePhone'
}, {
  key: 'accountName',
  name: '用户名'
}, {
  key: 'accountPassword',
  name: '密码'
}, {
  key: 'verifyCode',
  name: '验证码',
  validator: 'validateNumber'
}];
export default {
  components: {
    regAgreement: regAgreement
  },
  data: function data() {
    return {
      //用户协议
      checked: false,
      //表头宽度
      labelWidth: '85px',
      //验证码相关
      time: 60,
      timeInterval: null,
      // 表单
      formLogin: {
        accountName: '',
        accountPassword: '',
        verifyCode: '',
        accountPhone: ''
      },
      // 表单校验
      rules: setRules(rule),
      cookiesName: '',
      dialogFormVisible: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.cookiesName = this.$route.name + 'phone_code'; //页面加载判断cookies中是否存在倒计时

    if (YL.cookies.get(this.cookiesName) > 0) {
      this.time = YL.cookies.get(this.cookiesName);
      this.timeInterval = setInterval(function () {
        _this.refreshTime();
      }, 1000);
    }

    if (YL.cookies.get('loginForm')) {
      this.formLogin = JSON.parse(YL.cookies.get('loginForm'));
    }
  },
  methods: {
    //定时调用
    setTimeFn: function setTimeFn() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this2.timeInterval) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                _context.next = 4;
                return _this2.getCode();

              case 4:
                //设置定时器
                _this2.timeInterval = setInterval(function () {
                  _this2.refreshTime();
                }, 1000);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    //验证码倒计时
    refreshTime: function refreshTime() {
      //倒计时为1停止并清除cookies
      if (this.time == 0) {
        clearInterval(this.timeInterval);
        this.timeInterval = null;
        this.time = 60;
        YL.cookies.remove(this.cookiesName);
        return;
      }

      this.time = this.time - 1; //存入cookies,防止页面刷新后丢失倒计时

      YL.cookies.set(this.cookiesName, this.time);
    },
    //获取手机验证码
    getCode: function getCode() {
      var _this3 = this;

      return new Promise(function (reslove, reject) {
        _this3.$refs.loginForm.validateField('accountPhone', /*#__PURE__*/function () {
          var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(err) {
            var res;
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    if (!err) {
                      _context2.next = 2;
                      break;
                    }

                    return _context2.abrupt("return");

                  case 2:
                    _context2.next = 4;
                    return _this3.$api.registerCode({
                      accountPhone: _this3.formLogin.accountPhone
                    });

                  case 4:
                    res = _context2.sent;

                    if (!!res) {
                      _context2.next = 9;
                      break;
                    }

                    return _context2.abrupt("return", reslove(true));

                  case 9:
                    reject(false);

                  case 10:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2);
          }));

          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }());
      });
    },

    /**
     * @description 提交表单
     */
    // 提交注册信息
    submit: function submit() {
      var _this4 = this;

      this.$refs.loginForm.validate( /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(valid) {
          var accountPassword, form;
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  if (valid) {
                    _context3.next = 2;
                    break;
                  }

                  return _context3.abrupt("return");

                case 2:
                  if (_this4.checked) {
                    _context3.next = 4;
                    break;
                  }

                  return _context3.abrupt("return", YL.message('请阅读并同意《要炼企业用户注册协议》', 'error'));

                case 4:
                  accountPassword = YL.md5(_this4.formLogin.accountPassword);
                  form = _objectSpread(_objectSpread({}, _this4.formLogin), {}, {
                    accountPassword: accountPassword
                  });
                  _context3.next = 8;
                  return _this4.$api.register(form);

                case 8:
                  YL.message('注册成功,前往登录');

                  _this4.$router.replace('login');

                  YL.cookies.set('loginForm', {});

                case 11:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));

        return function (_x2) {
          return _ref2.apply(this, arguments);
        };
      }());
    },
    toNew: function toNew() {
      YL.cookies.set('loginForm', this.formLogin);
      this.goRoute('regAgreement');
    }
  }
};